import { rankingItems } from '@/mocks/homeData';

export default function Ranking() {
  return (
    <section id="ranking" className="py-12 md:py-16 px-4 md:px-6 bg-background-100/60">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100">
            <i className="ri-fire-line text-xl text-primary-600"></i>
          </div>
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">热度榜单</h2>
            <p className="text-xs md:text-sm text-foreground-500 mt-0.5">实时追踪最受关注的网红黑料</p>
          </div>
        </div>

        <div className="space-y-3">
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-3 md:gap-4 p-3 md:p-4 bg-background-50 rounded-lg border border-background-200/60 hover:border-primary-200/50 transition-colors cursor-pointer group"
            >
              <span className={`flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-lg font-bold text-sm ${
                item.rank === 1 ? 'bg-primary-500 text-white' :
                item.rank === 2 ? 'bg-primary-400 text-white' :
                item.rank === 3 ? 'bg-accent-400 text-white' :
                'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </span>

              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-medium text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
                  {item.title}
                </h3>
                <div className="flex items-center gap-2 mt-1">
                  <span className="text-xs bg-accent-100/80 text-accent-700 px-1.5 py-0.5 rounded whitespace-nowrap">{item.tag}</span>
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{item.time}</span>
                </div>
              </div>

              <span className="flex-shrink-0 text-xs md:text-sm font-semibold text-primary-600 whitespace-nowrap">{item.hot}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}